import { ReactElement } from 'react'

import CreateMotoristaImpl from 'modules/motorista/domain/usecases/CreateMotoristaImpl'
import MotoristaRepository from 'modules/motorista/infra/repositories/MotoristaRepository'
import CreateMotorista from 'modules/motorista/pages/CreateMotorista'

import ConsultZipCodeImpl from '../../../user/domain/usecases/ConsultZipCodeImpl'
import UserRepository from '../../../user/infra/repositories/UserRepository'

export const CreateMotoristaFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const motoristaRepository = new MotoristaRepository()
  const createMotorista = new CreateMotoristaImpl(motoristaRepository)
  const consultZipCodeImpl = new ConsultZipCodeImpl(userRepository)

  return (
    <CreateMotorista
      createMotorista={createMotorista}
      consultZipCode={consultZipCodeImpl}
    />
  )
}
